/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const GenericContentEvents = (props) => {
  const { cost, installs, clicks, bid_type, campaignGoalId, campaignStatus } = props.data;

  const isDeletedCampaign = useMemo(() => {
    return campaignStatus === 9;
  }, [campaignStatus]);

  function calcPercentageOfEvents(eventValue) {
    const isUa = campaignGoalId == 1;
    //const isRe = item.campaignGoalId == 2;
    let value;

    if (bid_type == 2) {
      value = isUa ? installs : clicks; // CPC
    } else {
      value = installs; // CPI, CPM
    }

    return calcPercentage(eventValue, value);
  }

  function calcCPAOfEvents(eventValue) {
    const cpa = eventValue > 0 ? cost / eventValue : 0;
    return cpa ? cpa.toFixed(2) : 0;
  }

  function calcPercentage(n1, n2) {
    return !n2 || !n1 ? '0' : ((n1 / n2) * 100).toFixed(0);
  }

  return (
    !isDeletedCampaign && (
      <Container>
        <div>{props?.value?.toLocaleString()}</div>
        <div>{calcPercentageOfEvents(props?.value)}%</div>
        <div>${calcCPAOfEvents(props?.value)}</div>
      </Container>
    )
  );
};

const Container = styled.div`
  height: 100%;
  padding: 0 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-left: 1px solid ${Palette.PrimaryGray._200};
`;
